import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, useContext } from 'react';
import { CourseLocationFormData } from '../data/CourseLocationForm.Data';
import FormCreator from '../../../../../components/forms/FormCreator';
import { useLazyGetIPASAddressesForEntriesQuery } from "../../../../../app/services/EventManagement/EventManagementApi"

const CourseLocation = forwardRef((props, ref) => {
    const courseLocationRef = useRef();
    const [courseLocationForm, setCourseLocationForm] = useState(CourseLocationFormData);
    const [getIPASAddressesForEntries, { isLoading: isipasaddressLoading, isSuccess: isipasaddressSuccess, data: ipasaddressResponse }] = useLazyGetIPASAddressesForEntriesQuery();
    const [formData, setFormData] = useState({ totalCount: "", itemList: [] });

    useEffect(() => {
        getIPASAddressesForEntries();
    }, []);

    useEffect(() => {
        if (!isipasaddressLoading && isipasaddressSuccess && ipasaddressResponse) {
            const updatedState = { ...courseLocationForm.initialState };
            ipasaddressResponse.forEach((responseObj) => {
                for (const key in updatedState) {
                    if (
                        updatedState.hasOwnProperty(key) &&
                        responseObj[key] != null
                    ) {
                        updatedState[key] = responseObj[key];
                    }
                }
            });
            setCourseLocationForm({
                ...courseLocationForm,
                initialState: updatedState,
            });


        }
    }, [isipasaddressLoading, isipasaddressSuccess, ipasaddressResponse]);

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (courseLocationRef.current) {
                return courseLocationRef.current.getFormData();
            }
            return null;
        }
    }));

    return (
        <React.Fragment>
            <div className="row">
                <FormCreator
                    config={courseLocationForm}
                    ref={courseLocationRef}
                    key={false}
                />
            </div>
        </React.Fragment>
    );
});

export default CourseLocation;
